import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    name: "home",
                    component: () => import('./views/Home.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/user-settings',
                    name: "users-list",
                    component: () => import('./views/user-settings/UserSettings.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/users',
                    name: "users-list",
                    component: () => import('./views/users/UsersList.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/two-factor',
                    name: 'two-factor',
                    component: () =>
                        import ('./views/users/TwoFactor.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/tenants',
                    name: "tenant-list",
                    component: () => import('./views/Tenants/Tenants.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/roles/list',
                    name: "roles-list",
                    component: () => import ('./views/roles/RolesList.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/roles/edit/:id',
                    name: "roles-list-update",
                    component: () => import ('./views/roles/RolesForm.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboard-analytics',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/control-panel',
                    name: 'dashboard-control-panel',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/maria-panel',
                    name: 'dashboard-maria-panel',
                    component: () => import ('./views/analytics/MetabaseAnalytics.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/produtivity-report',
                    name: 'dashboard-produtivity-report',
                    component: () => import ('./views/report/MetabaseReport.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/report',
                    name: "dashboard-report",
                    component: () => import ('./views/report/Report.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/dashboard/report-smart',
                    name: "dashboard-report-smart",
                    component: () => import ('./views/report/Report.vue'),
                    meta: {
                        rule: 'check'
                    }
                },
                {
                    path: '/info/:tenantName',
                    name: "info",
                    component: () => import ('./views/Tenants/TenantInfo.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'all'
                    }
                },

                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-son',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'all'
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.rule === 'check') {
        return next()
    }
    return next()
})

export default router
